<template>
   <b-card style="margin-bottom: 2rem">
      <div class="d-flex align-items-center justify-content-between">
         <h2 class="mb-0">Calculation</h2>

         <div class="d-flex align-items-center">
            <b-button
               id="btn-flags"
               variant="primary"
               :to="{name: 'credit-calculation-staff', params: {id: $companyId}}"
            >
               View
            </b-button>
         </div>
      </div>
   </b-card>
</template>

<script>
export default {
   name: 'CreditCalculationCard',
};
</script>
